import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from 'react';
import ConfirmCancelFooter from "./ConfirmCancelFooter";

const FooterContainer = _styled("div", {
  target: "e1438d1q0",
  label: "FooterContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "17nugpo",
  styles: "display:flex;align-items:flex-end;flex-direction:column;margin:20px;"
} : {
  name: "17nugpo",
  styles: "display:flex;align-items:flex-end;flex-direction:column;margin:20px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export const SiteSelectorDialogFooter = props => {
  const {
    canInstall,
    selectedSiteAndProduct,
    installAppHrefResolver,
    onClose,
    onRequestAppClick,
    requestAppHrefResolver,
    isFreeApp,
    onInstallClick,
    isLoading
  } = props;
  let footerProps;

  if (selectedSiteAndProduct && !canInstall) {
    footerProps = {
      href: requestAppHrefResolver(selectedSiteAndProduct),
      primaryCTALabel: 'Request app',
      testId: 'request-button',
      onPrimaryCTAClick: onRequestAppClick
    };
  } else {
    const primaryCTALabel = isFreeApp ? 'Install app' : 'Start free trial';
    footerProps = {
      href: selectedSiteAndProduct ? installAppHrefResolver(selectedSiteAndProduct) : '',
      primaryCTALabel,
      testId: 'install-button',
      onPrimaryCTAClick: e => {
        onInstallClick(isFreeApp, e);
      }
    };
  }

  return /*#__PURE__*/React.createElement(FooterContainer, null, /*#__PURE__*/React.createElement(ConfirmCancelFooter, _extends({}, footerProps, {
    onClose: onClose,
    isPrimaryDisabled: !selectedSiteAndProduct,
    isLoading: isLoading
  })));
};